import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setUser } from "../features/userSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import C_Navbar from "./C_Navbar";
import ENV from "../env";
import Google from "../Img/google.svg";
const Login = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const isDev = ENV.MODE === "dev";

  useEffect(() => {
    // ✅ Step 1: 如果 localStorage 有 token，就試著解析
    const saved = localStorage.getItem("token");
    // ✅ Step 2: 如果網址有 token，就處理
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    if (saved && !token) {
      try {
        const { token } = JSON.parse(saved);
        const decoded = jwtDecode(token);

        const isExpired = decoded.exp * 1000 < Date.now(); // JWT exp 是秒，要乘1000變成毫秒

        if (isExpired) {
          console.warn("⏰ token 已過期，登出中...");
          localStorage.removeItem("token");
          navigate("/", { replace: true });
          return;
        }

        if (decoded && decoded.email && decoded.name) {
          dispatch(setUser({ ...decoded, token }));
          navigate("/searchEmail", { replace: true });
          return;
        }
      } catch (err) {
        console.warn("⚠️ 無效的 token，將清除");
        localStorage.removeItem("token");
      }
    }

    if (token) {
      try {
        // ✅ 每次登入都清除之前的
        localStorage.removeItem("token");

        const user = jwtDecode(token);
        dispatch(setUser({ ...user, token }));
        localStorage.setItem("token", JSON.stringify({ token }));

        navigate("/searchEmail", { replace: true });
      } catch (err) {
        console.warn("⚠️ URL 中的 token 解析失敗");
      }
    }
  }, [location.search, dispatch, navigate]);

  const handleLogin = () => {
    window.location.href = `${
      isDev ? ENV.BACKEND_URL_DEV : ENV.BACKEND
    }/api/auth/google`;
  };

  return (
    <section className="login">
      <C_Navbar />

      <div className="login-container">
        <h1>登入系統</h1>
        <h2>
          此網站專門解決要註冊新系統沒有Email的人 <br />
          請登入全職人員的Google帳號
        </h2>
        <button onClick={handleLogin} className="login-googleBtn">
          <img src={Google} alt="Google" />
          使用 Google 登入
        </button>
      </div>
    </section>
  );
};

export default Login;
